import * as types from "./types";
import _ from "lodash";
export default (state = [], action) => {
  switch (action.type) {
    case types.FETCH_PENSION_MASTER_DDL:
      return { ..._.mapKeys(action.payload, "value") };
    case types.CREATE_PENSION_MASTER:
      return { ...state, ..._.mapKeys(action.payload, "value") };
    case types.EDIT_PENSION_MASTER:
      return { ...state, ..._.mapKeys(action.payload, "value") };
    case types.DELETE_PENSION_MASTER:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
